import gsap from "gsap";
import { enableScrollingForOverlay, disableScrollingForOverlay } from "~/js/components/overlay/helper";

let navItems:HTMLCollectionOf<Element>;

let mobileNavEl:HTMLElement|null;
let mobileNavContainerEl:HTMLElement|null|undefined;
let mobileNavExpandedEl:HTMLElement|null|undefined;
let mobileNavOpenBtnEl:HTMLElement|null|undefined;
let mobileNavCloseBtnEl:HTMLElement|null|undefined;

let headerEl:HTMLElement|null;
let headerObserver:IntersectionObserver;

let mobileMarkerEl:HTMLElement|null = null;

let openMobileNavTL:GSAPTimeline = gsap.timeline({
  paused: true,
  onStart: () => {
    mobileNavExpandedEl?.classList.remove('hidden');
    mobileNavContainerEl?.classList.add('opened');
  }
});
let closeMobileNavTL:GSAPTimeline = gsap.timeline({
  paused: true,
  onComplete: () => {
    mobileNavExpandedEl?.classList.add('hidden');
    mobileNavContainerEl?.classList.remove('opened');
  }
});

// Init nav elements after document is ready
export function initNav() {
  console.log('initNav()');

  navItems = document.getElementsByClassName('nav-item');

  console.log('navItems', navItems);

  mobileNavEl = document.querySelector('.nav.nav--mobile')
  mobileNavContainerEl = mobileNavEl?.querySelector('.nav-mobile__container');
  mobileNavExpandedEl = mobileNavEl?.querySelector('.nav-mobile__expanded');

  mobileNavOpenBtnEl = mobileNavEl?.querySelector('.nav-mobile__toggle-btn--open');
  mobileNavCloseBtnEl = mobileNavEl?.querySelector('.nav-mobile__toggle-btn--close');

  mobileNavOpenBtnEl?.addEventListener('click', () => {
    console.log('mobileNavOpenBtn clicked');
    openMobileNav();
  });

  mobileNavCloseBtnEl?.addEventListener('click', () => {
    console.log('mobileNavCloseBtn clicked');
    closeMobileNav();
  });

  // set up animation
  if( mobileNavExpandedEl ) {
    openMobileNavTL.set(mobileNavExpandedEl, {autoAlpha:1});
    openMobileNavTL.fromTo(mobileNavExpandedEl, {x:'-100%'}, {x:'0%', duration:0.5});
  

    closeMobileNavTL.to(mobileNavExpandedEl, {x:'-100%', duration:0.25});
    closeMobileNavTL.set(mobileNavExpandedEl, {autoAlpha:0});

    gsap.set(mobileNavExpandedEl, {autoAlpha:0});
  }

  // const observer = new IntersectionObserver( 
  //   ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
  //   { threshold: [1] }
  // );

  headerEl = document.querySelector('header');
  mobileMarkerEl = document.querySelector('.view-mobile-marker');
  if( mobileMarkerEl !== null ) {
    headerObserver = new IntersectionObserver(
      ([e]) => {
        if( window.innerWidth < 1024 ) {
          // console.log('e.intersectionRatio:', e.intersectionRatio);
          headerEl?.classList.toggle('pinned', e.intersectionRatio < 1);
        }
      },
      {
        threshold: 1.0
      }
    )
    headerObserver.observe(mobileMarkerEl);
  }
  
  
}


function openMobileNav() {
  disableScrollingForOverlay();

  if( closeMobileNavTL ) {
    closeMobileNavTL.pause();
  }

  openMobileNavTL.restart();
}

function closeMobileNav() {
  if( openMobileNavTL ) {
    openMobileNavTL.pause();
  }

  
  closeMobileNavTL.restart();

  enableScrollingForOverlay();
}

